// infcode_change - metrics foundation

// 整段匹配（含 key 名）一并替换为 [REDACTED]
const PATTERNS: RegExp[] = [
  /bearer\s+[A-Za-z0-9\-_.~+/]+=*/gi,
  /(?:["']?api[-_]?key["']?\s*[:=]\s*["']?)[^"',\s}]+/gi,
  /(?:["']?(?:access|refresh|auth)[-_]?token["']?\s*[:=]\s*["']?)[^"',\s}]+/gi,
  /[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}/g,
]

const REDACT_INPUT_SLACK = 512 // 容纳跨截断边界的完整 token/email

export function redact(input: string): string {
  return PATTERNS.reduce((acc, pattern) => acc.replace(pattern, "[REDACTED]"), input)
}

export function truncate(input: string, max: number): string {
  return input.length > max ? input.slice(0, max) : input
}

export function sanitizeDetail(input: string, max: number): string {
  return truncate(redact(truncate(input, max + REDACT_INPUT_SLACK)), max)
}

export const ERROR_DETAIL_LIMIT = 2_000
export const PANIC_STACK_LIMIT = 4_000
